import React from "react"
import { isMobile } from "react-device-detect";
import { SpbButton } from "shared/components/spb-button/spb-button";
import { ArrowLeft } from "shared/components/spb-icons/arrow-left";
import { ArrowRight } from "shared/components/spb-icons/arrow-right";

export interface IFormulaireSubmitProps {
    inProgress?:boolean;
    previous?:()=> void;
    next?:()=>void;
    recap?: any;
}

export const FormulaireSubmit:React.FC<IFormulaireSubmitProps> = ({inProgress, next, previous,recap}) => {



    return (
        <div>
         
        <div className={previous ? "row f" : "row f f3"}>
        {recap && <p className="text-center fw-bold" style={isMobile ? {marginTop:'2rem'} : {}} >En cliquant ci-dessous, je confirme ma demande de mon contrat d'assurance</p>}
         {previous && (
        <div className="col-6 ">
            <div className="previous boxrigth">
              <SpbButton name="button-previous" type="button" onClick={previous} className="buttonleft" >
                    {/* <ArrowLeft width={35} className="ArrwoRight" style={{stroke:"#A128A8"}}/> */}
                    &nbsp;Précédent
                </SpbButton>
            </div>
        </div>  
        )}
        <div className="col-6 ">
            
            {recap ? <div className="next boxleft">
                <SpbButton inProgress={inProgress} name="button-next"   type="submit"  onClick={next} className="buttonRight">
                Je confirme mon souhait de renoncer ou résilier&nbsp;
                {/* <ArrowRight width={35} style={{stroke:"#fff"}} className="ArrwoRight"/> */}
                </SpbButton>
            </div>
            :
            <div className="next boxleft">
                <SpbButton inProgress={inProgress} name="button-next" type="submit"  onClick={next} className="buttonRight">
                Suivant&nbsp;
                {/* <ArrowRight width={35} style={{stroke:"#fff"}} className="ArrwoRight"/> */}
                </SpbButton>
            </div>
            }
        </div>
    </div>
    </div>
    )
}